// extracted by mini-css-extract-plugin
export default {"link":"NavbarItems_link__cQvj6"};